<script>
export default {
  name: 'ScoreBar',
  props: {
    /** Score de complétude, entier 0-100. `null` = l'API ne l'a pas fourni. */
    score: { type: Number, default: null },
    /** Nombre de champs renseignés, pour l'infobulle. */
    answered: { type: Number, default: null },
    /** Nombre de champs attendus, pour l'infobulle. */
    total: { type: Number, default: null },
  },
  computed: {
    /*
      Une API plus ancienne ne renvoie pas encore ces trois champs. Une ligne
      sans score doit rester lisible plutôt que d'afficher « NaN % » — et pas
      davantage une barre à zéro: « on ne sait pas » n'est pas « rien de
      rempli ». D'où le tiret rendu à la place de la barre.
    */
    hasScore() {
      return typeof this.score === 'number' && Number.isFinite(this.score);
    },

    /* Le score vient du serveur: on le borne pour ne jamais dessiner hors piste. */
    value() {
      if (!this.hasScore) {
        return 0;
      }

      return Math.min(100, Math.max(0, Math.round(this.score)));
    },

    /*
      Les paliers disent d'un coup d'oeil ce qu'un nombre seul oblige à lire:
      rouge = enquête à peine commencée, vert = prête à être soumise.
    */
    bandClass() {
      if (this.value < 25) {
        return 'score-bar__fill--danger';
      }

      if (this.value < 50) {
        return 'score-bar__fill--warning';
      }

      if (this.value < 75) {
        return 'score-bar__fill--caution';
      }

      return 'score-bar__fill--success';
    },

    /*
      L'infobulle explique le pourcentage. Sans les deux compteurs elle
      n'apprendrait rien: on n'écrit alors pas l'attribut du tout.
    */
    titleText() {
      const hasCounts =
        Number.isFinite(this.answered) && Number.isFinite(this.total);

      if (!hasCounts) {
        return null;
      }

      return `${this.answered} / ${this.total} champs renseignés`;
    },

    ariaLabel() {
      return `Complétude : ${this.value} %`;
    },
  },
};
</script>

<template>
  <span
    v-if="!hasScore"
    class="score-bar score-bar--unknown"
    title="Complétude non calculée"
    >—</span
  >

  <span v-else class="score-bar" :title="titleText">
    <span
      class="score-bar__track"
      role="progressbar"
      :aria-valuenow="value"
      aria-valuemin="0"
      aria-valuemax="100"
      :aria-label="ariaLabel"
    >
      <span
        class="score-bar__fill"
        :class="bandClass"
        :style="{ width: value + '%' }"
      ></span>
    </span>
    <span class="score-bar__value">{{ value }} %</span>
  </span>
</template>
